module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "sec6"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" "), _c('em', [_vm._v("Elegy")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "sec7"
    }
  }), _vm._v("Landscape with the Fall of Icarus")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("How could I have failed you like this?"), _c('br'), _vm._v("The narrator asks")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The object. The object is a box"), _c('br'), _vm._v("Of ashes. How could I not have saved you,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("A boy made of bone and blood. A boy"), _c('br'), _vm._v("Made of a mind. Of years. A hand")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And paint on canvas. A marble carving."), _c('br'), _vm._v("How can I not reach where you are")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And pull you back. How can I be"), _c('br'), _vm._v("And you not. You’re forever on the platform")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Seeing the pattern of the train door closing."), _c('br'), _vm._v("Then the silver streak of me leaving.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("What train was it? The number 6."), _c('br'), _vm._v("What day was it? Wednesday.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We had both admired the miniature mosaics"), _c('br'), _vm._v("Stuck on the wall of the Met.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That car should be forever sealed in amber."), _c('br'), _vm._v("That dolorous day should be forever")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Embedded in amber."), _c('br'), _vm._v("In garnet. In amber. In opal. In order")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To keep going on. And how can it be"), _c('br'), _vm._v("That this means nothing to anyone but me now.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b338a74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_c.vue
// module id = 93
// module chunks = 0